module.exports = require('./helpers/bundle-url').getBundleURL('1Xqbz') + "logo-dark.eefe0b7f.svg";